import Component from '@glimmer/component';

interface ResultsTableSignature<T> {
  Args: {
    data: T[];
  };
  Blocks: {
    header?: [];
    footer?: [T[]];
    row?: [item: T, index: number];
  };
  Element: HTMLTableElement;
}

export class ResultsTable<T> extends Component<ResultsTableSignature<T>> {
  <template>
    <table class="table table-sm" ...attributes>
      {{#if (has-block "header")}}
        <thead>
          <tr>
            {{yield to="header"}}
          </tr>
        </thead>
      {{/if}}
      <tbody>
        {{#if (has-block "row")}}
          {{#each @data as |item index|}}
            {{yield item index to="row"}}
          {{/each}}
        {{/if}}
      </tbody>
      {{#if (has-block "footer")}}
        <tfoot>
          <tr>
            {{yield @data to="footer"}}
          </tr>
        </tfoot>
      {{/if}}
    </table>
  </template>
}
